<template>
  <el-row class="cs-fullHeight backgroud-light-gray">
    <el-row>
      <el-col :span="4" class="cs-courseFreeVideoCountList-container">
        <div class="cs-courseFreeVideoCountList">
          <el-row v-if="!!courseFreeVideoCountList && courseFreeVideoCountList.length > 0">
            <el-col>
              <span>当前学期免费观看次数:</span>
              <span v-for="item in courseFreeVideoCountList" :key="item.CourseId">{{ item.CourseName }}({{
    item.FreeVideoCount
}}次免费)</span>
            </el-col>
          </el-row>
          <!-- <el-row class="cs-video-notice">
            <el-col>
              <span>注意事项:</span>
              <span>1.
                对于观看方式为“线上付费/线下免费”课程，同学可使用余额或者积分抵扣费用进行线上观看。想免费观看的同学，可到速成学员portal进行时间预约，到预约校区进行观看。
              </span>
            </el-col>
          </el-row> -->
          <el-row class="cs-video-notice">
            <el-col>
              <span>1.
                对于观看方式为“线上免费”的课程，同学可通过云教室播放视频。</span>
            </el-col>
          </el-row>
          <el-row class="cs-video-notice">
            <el-col>
              <span>2.
                当视频开始播放时，请参考屏幕下方倒计时了解【视频剩余总时长】，关闭,暂停播放器或者退出登录，系统将停止计时。</span>
            </el-col>
          </el-row>
          <el-row class="cs-video-notice">
            <el-col>
              <span>3.
                以上对于观看视频存在任何问题，请联系校区前台工作人员帮助解决。</span>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col class="video-appointment-list-content" :xs="20" :sm="20" :md="16">
        <el-tabs type="border-card" v-model="activeTab">
          <el-tab-pane name="1">
            <span slot="label">视频列表</span>
            <videoList ref="videoList" :listType="1" :isActive="activeTab=='1'" @showWatchHistoryList="showWatchHistoryListHandler" @customEvent="customEventHandler"></videoList>
          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label">预约列表</span>
            <videoList ref="appointmentList" :listType="2" :isActive="activeTab=='2'"  @showWatchHistoryList="showWatchHistoryListHandler" @customEvent="customEventHandler"></videoList>
          </el-tab-pane>
        </el-tabs>
        <!-- <span class="cs-title cs-title-color">预约列表</span>
        <el-button v-show="stepIndex === 1" size="small" style="float: right" @click="onReturnClick">返回</el-button>
        <el-row class="grid-content">
          <el-col>
            <pagination v-show="stepIndex === 1" v-loading="loading" :data="listData" @loadData="onListDataLoad"
              :option="paginationOption" @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange"
              @customEvent="customEventHandler" @edit="onEdit"></pagination>
            <pagination v-show="stepIndex !== 1" v-loading="loading" :data="vaCoursePageData"
              @loadData="onVACoursePageDataLoad" :option="vaCoursePaginationOption"
              @pageSizeChange="vaCoursePageSizeChange" @currentPageChange="vaCourseCurrentPageChange"
              @customEvent="vaCourseCustomEventHandler"></pagination>
          </el-col>
        </el-row> -->
      </el-col>
    </el-row>
    <el-row class="footer-description">
      <el-col>
        <footer>
          <el-row class="footer-content" v-show="showTimeDown">
            <el-col :span="20" class="cs-main-left-container footer-left" :offset="4">
              <span v-if="bypassVideoAppointment" class="cs-footer-time">您的预约计时已开始 {{ timeDownShow }}</span>
              <span v-else>您的预约计时已于{{ appStartTime }}开始 {{ timeDownShow }}</span>
              <span class="cs-video-warning">(若需分次观看，请关闭播放器或者退出登录。若无法一次性观看完整视频，请暂停或者退出登录。持续播放讲导致观看时长被耗尽。)</span>
            </el-col>
            <!-- <el-col :span="7" class="cs-main-right-container footer-right">
              <span v-if="!bypassVideoAppointment">
                进入
                <a href="http://portal.speedupedu.com" target="_blank">学员账户中心</a> 添加新预约
              </span>
            </el-col> -->
          </el-row>
        </footer>
      </el-col>
    </el-row>

    <videoPlayer :playerVisible="playerDialogVisible" :url="url" @onCloseDialog="onCloseDialog"></videoPlayer>
    <videoPlayerHjt :playerVisible="playerDialogVisibleHjt" :videoData="hjtVideoData" @onCloseDialog="onCloseDialogHjt">
    </videoPlayerHjt>
    <videoPlayerH5 :playerVisible="playerDialogVisibleH5" :videoData="hjtVideoData" @onCloseDialog="onCloseDialogH5">
    </videoPlayerH5>
    <video id="video" width="500px" height="500px" muted playsinline autoplay v-show="showVideo" ref="videoBox"></video>
    <canvas id="canvas" width="500px" height="500px" style="display: none" ref="videoCanvas"></canvas>
    <img src id="img" />
    <timeDownDiolog :timeDownDialogVisible="timeDownDialogVisible" @onOk="confirmCloseTimeDownDialog"></timeDownDiolog>
    <el-dialog v-loading="loadingPayment" element-loading-text="正在保存支付" title="添加支付" :center="true"
      :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <payEditor @save="onSavePayment" :dataIn="paymentEditorData"></payEditor>
    </el-dialog>
    <el-dialog title="历史记录" :center="true" :close-on-click-modal="false" width="60%"
      :visible.sync="watchHistoryListVisible" top="3vh">
      <watchHistoryList :data="watchHistoryData"></watchHistoryList>
    </el-dialog>
    <el-dialog v-if="wechartLoginVisible" title="验证微信" :center="true" :close-on-click-modal="false"
      :visible.sync="wechartLoginVisible" top="8vh">
      <wechartLogin action="validation" @success="onWechartLoginSuccess" @fail="onWechartLoginFail"></wechartLogin>
    </el-dialog>
    <el-dialog class="cs-sproutVideo-container" v-if="sproutVideoViewVisible" :center="true"
      :close-on-click-modal="false" :visible.sync="sproutVideoViewVisible" @close="onCloseSproutVideo" top="8vh"
      width="900px">
      <div v-loading="isVideoloading">
        <div v-html="sproutVideoPath"></div>
      </div>
    </el-dialog>

    <el-dialog class="cs-aliyunVideo-container" v-if="aliyunVideoViewVisible" :center="true"
      :close-on-click-modal="false" :visible.sync="aliyunVideoViewVisible" @close="onCloseAliyunVideo" top="8vh"
      width="900px">
      <div v-loading="isVideoloading" class="cs-aliyunVideo-player-container">
        <div class="cs-aliyunVideo-player" id="aliyunVideoPlayer"></div>
      </div>
    </el-dialog>

    <el-dialog title="验证预约" :center="true" :close-on-click-modal="false" width="40%" :visible.sync="tokenEditorVisible"
      top="3vh">
      <tokenEditor :dataIn="tokenEditorData" @tokenValid="onTokenValid"></tokenEditor>
    </el-dialog>

    <studentQuestionnaireEditor key="studentQuestionnaireEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" @completed="onStudentQuestionnaireEditorCompleted" />
  </el-row>
</template>

<script>
import { getFileContainerList } from "../service/common.service";
import {
  getSharedAccessSignature,
  saveUploadFile,
} from "../service/blobStorage.service";
import {
  uploadFileToBlobStorage,
  uploadBufferToBlobStorage,
} from "../filters/blobStorage";

import payEditor from "../components/common/payEditor";
import watchHistoryList from "../components/watchHistoryList";
import wechartLogin from "../components/common/wechartLogin";
import videoList from "../components/videoList";
import Aliplayer from 'aliyun-aliplayer';
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';

import {
  isIOSDevice,
  setStore,
  clearUserInStore,
  getTimeDiff,
  setMediaDevices,
  getBrowerInfo,
} from "../config/mUtils";
import { getVideoData, getVideoPlayAuth, getStsCredentials } from "../service/player.service";
import { getStudentMemberInfo } from "../service/student.service";
import { saveCaptureImage } from "../service/captureImage.service";
import {
  getBonusPointMechanismByType,
  saveClientSideError,
} from "../service/common.service";

import {
  getVACoursePageData,
  getVideoAppointmentList,
  getCurrentVideoAppoint,
  checkIsWatchApproved,
  updateWatchSeconds,
  getVideoAppointmentPrice,
  savePayment,
  checkOnlineCourse,
} from "../service/videoAppointment.service";
import { getStudentCoursesQuestionnaireStatus } from "@/service/questionnaire.service";
import videoPlayer from "../components/videoPlayer";
import videoPlayerHjt from "../components/videoPlayerHjt";
import videoPlayerH5 from "../components/videoPlayerH5";
import timeDownDiolog from "../components/timeDownDialog";
import tokenEditor from "../components/tokenEditor";
import global_ from "@/core/global";

export default {
  data() {
    return {
      stepIndex: 0,
      selectCourse: null,
      showVideo: false,
      wechatEnable: false,
      wechartLoginVisible: false,
      loadingPayment: false,
      doublePriceMinutes: 300,
      studentInfo: {},
      priceSettings: {},
      paymentEditorData: {},
      paymentEditorVisible: false,
      supplementVideoPrice: {},
      currentRow: {},
      currentPrice: 0,
      loading: false,
      editData: {},
      editIndex: -1,
      dialogEditorVisible: false,

      playerDialogVisible: false,
      playerDialogVisibleHjt: false,
      playerDialogVisibleH5: false,
      sproutVideoViewVisible: false,
      sproutVideoPath: "",
      sproutVideoId: "",
      sproutPlayer: null,
      isSproutPlayerPlay: false,

      aliyunVideoViewVisible: false,
      aliyunVideoPath: "",
      aliyunVideoId: "",
      aliyunVideoRegionId: "",
      aliyunVideoPlayer: null,
      isAliyunVideoPlayerPlay: false,
      hideAliyunVideoPlayerError: false,
      availableMinutes: 0,

      isVideoloading: false,
      id: -1,
      url: "",
      timeDownShow: "",
      timer: null,
      timerUpdateWatch: null,
      timerUpdateCaptureImage: null,
      timerCheckCamera: null,
      captureInvtervalTime: 30 * 60 * 1000,
      checkCameraTime: 10000,
      timeDownDialogVisible: false,
      showTimeDown: false,
      appStartTime: "",
      hjtVideoData: {
        vid: "",
        ts: 0,
        sign: "",
      },
      bypassVideoAppointment: global_.bypassVideoAppointment,
      watchHistoryData: {},
      watchHistoryListVisible: false,
      courseFreeVideoCountList: [],
      currentEventData: {},
      videoTracks: [],
      containerList: [],
      CaptureImageType: 10,
      containerName: "",
      sasKey: "",
      currentCourseActivationId: 0,
      activeTab: "1",
      pauseTime: null,
      studentCoursesQuestionnaireStatus: [],
      tokenEditorData: {},
      tokenEditorVisible: false,

      canPlayVideo: false
    };
  },
  components: {
    videoPlayer,
    videoPlayerHjt,
    videoPlayerH5,
    timeDownDiolog,
    payEditor,
    watchHistoryList,
    wechartLogin,
    videoList,
    tokenEditor,
    studentQuestionnaireEditor: () =>
      import("@/components/questionnaire/studentQuestionnaireEditor"),
  },
  created() {
    setMediaDevices();
    
    setStore("show-admin-hader", "false");
    this.$emit("page-changed-event", true);
    if (!this.bypassVideoAppointment) {
      this.getCurrentVideoAppoint();
    }

    getBonusPointMechanismByType(2).then((result) => {
      if (result && result.success) {
        this.priceSettings.bonusPointToMoney_Money = result.data.Money;
        this.priceSettings.bonusPointToMoney_BonusPoint =
          result.data.BonusPoint;
      }
    });
    this.loadVASupplementPrice();
    this.getStudentInfo();
    getSharedAccessSignature().then((result) => {
      if (!!result && result.success) {
        this.sasKey = result.data;
      }
    });
    getFileContainerList().then((result) => {
      if (!!result && result.success) {
        this.containerList = result.data;
        this.getContainerName();
      }
    });
  },
  mounted() { },
  methods: {
    async loadStudentCoursesQuestionnaireStatusFromServer() {
      let studentId = this.studentInfo.StudentId;
      try {
        let result = await getStudentCoursesQuestionnaireStatus(studentId);

        this.studentCoursesQuestionnaireStatus =
          !!result && result.success ? result.data : [];
      } catch (error) {
        console.error(error);
      }
    },

    onWechartLoginFail() {
      this.wechartLoginVisible = false;
    },
    onWechartLoginSuccess() {
      this.loading = true;
      setTimeout(() => {
        this.wechartLoginVisible = false;
        this.beforeHandleViewVideo();
      }, 2000);
    },
    showWatchHistoryListHandler(row) {
      this.watchHistoryData = {
        courseName: row.CourseName,
        courseWeekString: row.CourseWeekString,
        courseActivationId: row.CourseActivationId,
      };
      this.watchHistoryListVisible = true;
    },
    getPaymentEditorData(price) {
      this.paymentEditorData = {
        price: price,
        memberInfo: this.studentInfo,
        priceSettings: this.priceSettings,
      };
    },
    showAddPaymentEditor(data) {
      this.currentPrice = this.getVideoPrice(data);
      this.getPaymentEditorData(this.currentPrice);
      this.paymentEditorVisible = true;
    },
    onSavePayment(data) {
      this.loadingPayment = true;
      let courseActivationId = this.currentRow.CourseActivationId;
      let isCheckCamera = this.currentRow.IsCheckCamera;
      savePayment(
        courseActivationId,
        this.currentPrice,
        data.balanceCost,
        data.bonusPointCost,
        data.bonusPointPrice
      )
        .then((result) => {
          if (result && result.success) {
            let videoAppointmentId = result.data;
            this.currentRow.Id = videoAppointmentId;
            this.currentRow.IsWatchApproved = true;
            this.currentRow.SignInStatus = "已缴费(可观看)";
            this.loading = true;
            this.getStudentInfo();
            this.getCurrentVideoAppoint(
              isCheckCamera,
              videoAppointmentId,
              courseActivationId
            );
          } else {
            this.$message.error(result.message);
            this.loadingPayment = false;
          }
          this.paymentEditorVisible = false;
        })
        .catch(() => {
          this.loadingPayment = false;
        });
    },
    loadVASupplementPrice() {
      getVideoAppointmentPrice().then((result) => {
        if (!!result && result.success) {
          this.supplementVideoPrice = result.data;
        }
      });
    },
    async getStudentInfo() {
      try {
        let result = await getStudentMemberInfo();

        if (!!result && result.success) {
          this.studentInfo = result.data;
          this.courseFreeVideoCountList =
            this.studentInfo.CourseFreeVideoCountList.filter(
              (i) => !i.IsVideoCourse && i.FreeVideoCount > 0
            );
          await this.loadStudentCoursesQuestionnaireStatusFromServer();
        }
      } catch (error) {
        console.error(error);
      }
    },
    getVideoPrice(data) {
      let price = this.supplementVideoPrice.Price;
      if (data.CourseMinutes > this.doublePriceMinutes) {
        price = this.supplementVideoPrice.DoublePrice;
      }
      return price;
    },

    async customEventHandler(data) {
      this.currentEventData = null;
      if (data.name == "view") {
        this.currentEventData = data;
        if (this.wechatEnable) {
          this.wechartLoginVisible = true;
        } else {
          this.beforeHandleViewVideo();
        }
        //测试全屏关闭
        // window.setTimeout(()=>{
        //   this.playerDialogVisibleHjt = false;
        // }, 3000)
      }

    },
    beforeHandleViewVideo() {
      let data = this.currentEventData;
      let studentId = data.row.StudentId;
      let courseId = data.row.CourseId;
      if (this.studentCoursesQuestionnaireStatus.some(item => item.CourseId === courseId && item.HaveActiveQuestionnaires)) {
        this.openStudentQuestionnaireEditor(studentId, courseId);
      } else {
        this.handleAppointment();
      }
    },
    handleAppointment(){
      let data = this.currentEventData;
      let row = data.row;
      if (row.IsAppointment){
        if (row.IsCompleted){
          this.$message.warning("该预约课节已观看完毕，无可用观看时长");
          return;
        }
        this.showTokenEditor(row.Id);
      }else{
        this.handleViewVideo(data);
      }
    },
    async handleViewVideo(data) {
      this.currentRow = data.row;
      let videoAppointmentId = data.row.Id;
      let courseActivationId = data.row.CourseActivationId;
      let isCheckCamera = data.row.IsCheckCamera;
      if (!this.bypassVideoAppointment) {
        let isValid = await this.checkAppointmentTime(data.row);
        if (!isValid) {
          return;
        }

        this.onOpenDialog(
          isCheckCamera,
          videoAppointmentId,
          courseActivationId
        );
      } else {
        if (
          data.row.IsSproutVideo &&
          !!data.row.SproutVideoPath &&
          !data.row.IsSproutVideoReady
        ) {
          this.$message.warning("视频文件还未转码完成，无法播放。请稍后重试。");
          return;
        }
        if (data.row.IsOnlineCourse) {
          let onlineCourseResult = await checkOnlineCourse(courseActivationId);
          if (!onlineCourseResult.success) {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: onlineCourseResult.message,
              type: "warning",
              duration: 10000,
            });
            return;
          }
        }
        let descSproutVideo = ""; // this.getDescForSproutVideo(data.row);
        if (!data.row.IsWatchApproved) {
          let isUseFreeVideoCount = false;
          let stuentFreeCourse = this.studentInfo.CourseFreeVideoCountList.find(
            (i) => i.CourseId == data.row.CourseId
          );
          //if (!!stuentFreeCourse && !data.row.IsNormalSignIn) {
          if (!!stuentFreeCourse) {
            isUseFreeVideoCount = stuentFreeCourse.FreeVideoCount > 0;
          }

          let msg = "";
          if (isUseFreeVideoCount) {
            msg =
              "您本学期还有 " +
              stuentFreeCourse.FreeVideoCount +
              " 次免费观看课程 " +
              stuentFreeCourse.CourseName +
              " 视频机会。" +
              descSproutVideo +
              " 您确定要观看 " +
              data.row.CourseName +
              " 课程周 " +
              data.row.CourseWeekString +
              " 的视频吗？";
          } else {
            msg =
              data.row.CourseName +
              " 课程周 " +
              data.row.CourseWeekString +
              " 需交费后才能继续观看。" +
              descSproutVideo +
              " 是否继续？";
          }
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              if (isUseFreeVideoCount) {
                this.getCurrentVideoAppoint(
                  isCheckCamera,
                  videoAppointmentId,
                  courseActivationId,
                  isUseFreeVideoCount
                );
              } else {
                this.showAddPaymentEditor(data.row);
              }
            })
            .catch(() => { });
        } else {
          let msg =
            descSproutVideo +
            " 您确定要开始观看 " +
            data.row.CourseName +
            " 课程周 " +
            data.row.CourseWeekString +
            " 的视频吗？点击确认后即将开始计时。";
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.getCurrentVideoAppoint(
                isCheckCamera,
                videoAppointmentId,
                courseActivationId
              );
            })
            .catch(() => { });
        }
      }
    },
    getDescForSproutVideo(row) {
      if (
        row.IsSproutVideo &&
        !!row.SproutVideoPath &&
        !row.IsSproutVideoReady
      ) {
        return "视频文件还未转码完成，可能无法播放。";
      }
      return "";
    },
    onCloseDialog() {
      this.playerDialogVisible = false;
      if (this.bypassVideoAppointment) {
        this.clearTimer();
      }
    },
    closeCamera() {
      if (!!this.videoTracks) {
        this.videoTracks.forEach((track) => {
          try {
            track.stop();
          } catch (error) {
            console.log(error);
          }
        });
      }
    },
    checkCamera(ignoreError) {
      if (typeof ignoreError == undefined) {
        ignoreError = false;
      }
      let isAvailable = false;
      if (!!this.videoTracks) {
        this.videoTracks.forEach((track) => {
          let msg = "";
          if (!!track) {
            msg =
              "enabled:" +
              track.enabled.toString() +
              ", readyState:" +
              track.readyState.toString();
          }

          try {
            isAvailable = track.enabled && track.readyState == "live";
            if (!isAvailable && !ignoreError) {
              saveClientSideError("检测摄像头失败", msg);
            }
          } catch (error) {
            msg += ", error:" + error.toString();
            if (!ignoreError) {
              saveClientSideError("检测摄像头出错", msg);
            }
            console.log(error);
          }
        });
      }
      return isAvailable;
    },
    async onOpenDialog(
      isCheckCamera,
      videoAppointmentId,
      courseActivationId,
      isUseFreeVideoCount
    ) {
      try {
        if (isCheckCamera) {
          var stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: true,
          });
          var video = this.$refs.videoBox;
          video.srcObject = stream;
          if ("srcObject" in video) {
            video.srcObject = stream;
          } else {
            video.src = window.URL.createObjectURL(stream);
          }

          this.videoTracks = stream.getVideoTracks();
          this.getVideoUrl(
            videoAppointmentId,
            courseActivationId,
            isUseFreeVideoCount
          );
          this.openCamera(video);
          setTimeout(() => {
            this.updateCaptureImage(courseActivationId);
          }, 3000);

          this.clearIntervalTimer(this.timerUpdateCaptureImage);
          this.clearIntervalTimer(this.timerCheckCamera);

          this.timerUpdateCaptureImage = setInterval(() => {
            this.updateCaptureImage(courseActivationId);
          }, this.captureInvtervalTime);

          this.timerCheckCamera = setInterval(() => {
            if (!this.checkCamera()) {
              this.$message.warning("摄像头已关闭，无法观看视频");
              this.onCloseDialogH5();
            }
          }, this.checkCameraTime);
        } else {
          return this.getVideoUrl(
            videoAppointmentId,
            courseActivationId,
            isUseFreeVideoCount
          );
        }

        return true;
      } catch (error) {
        if (error.message == "Permission dismissed") {
          this.$message.error("请设定摄像头权限,然后刷新重新点击‘开始观看’");
        } else if (
          error.message == "Permission denied" ||
          error.name === "PermissionDeniedError"
        ) {
          this.$message.error(
            "您已拒绝使用摄像头,请重新打开摄像头权限(点击地址栏右边的摄像头图标)"
          );
        } else {
          this.$message.error(
            "使用摄像头失败,请确保当前浏览支持摄像头,或确保浏览器有权限访问摄像头"
          );
        }
        console.log(error);

        let msg = error.toString();
        msg =
          msg +
          "; 浏览器: " +
          getBrowerInfo() +
          "; userAgent: " +
          window.navigator.userAgent;
        saveClientSideError("打开摄像头失败", msg);
        this.loading = false;
        return false;
      }
    },
    openCamera(video) {
      window.setTimeout(() => {
        if (!this.checkCamera(true)) {
          if (typeof video.play != undefined) {
            video.play();
          }
        }
      }, 500);
    },
    onCloseDialogHjt() {
      this.playerDialogVisibleHjt = false;
      if (this.bypassVideoAppointment) {
        this.clearTimer();
      }
    },
    onOpenDialogHjt(
      videoAppointmentId,
      courseActivationId,
      isUseFreeVideoCount
    ) {
      this.getVideoUrl(
        videoAppointmentId,
        courseActivationId,
        isUseFreeVideoCount
      );
    },
    onCloseDialogH5() {
      this.playerDialogVisibleH5 = false;
      if (this.bypassVideoAppointment) {
        this.clearTimer();
      }
    },
    confirmCloseTimeDownDialog() {
      this.timeDownDialogVisible = false;
      this.logoutUser();
    },
    openTimeDownDialog() {
      this.timeDownDialogVisible = true;
    },
    logoutUser() {
      clearUserInStore();
      this.$router.push("/login");
    },
    getVideoUrl(videoAppointmentId, courseActivationId, isUseFreeVideoCount) {
      let row = this.getCurrentRow(courseActivationId);
      if (row.VideoPlatform === 1){
        if (!!row.AliyunVideoId){
          this.viewAliyunVideo(
            videoAppointmentId,
            courseActivationId,
            isUseFreeVideoCount,
            row
          );
        }
        this.loadingPayment = false;
        this.loading = false;
        return true;
      } else if (row.IsSproutVideo && !!row.SproutVideoPath) {
        this.viewSproutVideo(
          videoAppointmentId,
          courseActivationId,
          isUseFreeVideoCount,
          row
        );
        this.loadingPayment = false;
        this.loading = false;
        return true;
      }

      if (!row.VideoName) {
        this.$notify({
          message: "视频文件未设置，请联系客服",
          type: "warning",
          duration: 10000,
        });
        this.clearTimer();
        this.loadingPayment = false;
        this.loading = false;
        return false;
      }

      this.loading = true;
      getVideoData(courseActivationId).then((result) => {
        this.loading = false;
        this.loadingPayment = false;
        if (result.success) {
          if (result.data.HasVid) {
            this.hjtVideoData = {
              vid: result.data.Vid,
              ts: result.data.TS,
              sign: result.data.Sign,
              playsafe: result.data.Playsafe,
            };
            this.playerDialogVisible = false;
            this.playerDialogVisibleH5 = true;
          } else {
            this.$message.error("视频文件转码中，请稍后重试");
            this.clearTimer();
            return;
          }

          this.updateWatch(
            videoAppointmentId,
            courseActivationId,
            isUseFreeVideoCount
          );
        } else {
          this.$message.error(result.message);
          this.clearTimer();
        }
      });
      return true;
    },
    async checkAppointmentTime(data) {
      if (!data) {
        return false;
      }

      let result = await checkIsWatchApproved(data.Id);
      if (!result.data) {
        this.$message.warning("请通知并等待管理员进行审批");
        return false;
      }

      let dateTimeStr = data.AppDateString + " " + data.AppStartTimeText;
      let date = new Date(data.AppDateString);
      let time = new Date(dateTimeStr);
      let nowDate = new Date();

      let message = "";
      if (nowDate < time) {
        let str = getTimeDiff(dateTimeStr);
        message = "未到预约时间: " + dateTimeStr + ", 还剩: " + str + " 可播放";
      }
      if (!!message) {
        this.$message.warning(message);
        return false;
      }
      return true;
    },
    getContainerName() {
      // debugger;
      if (
        !!this.CaptureImageType &&
        !!this.containerList &&
        this.containerList.length > 0
      ) {
        let container = this.containerList.find(
          (i) => i.Key == this.CaptureImageType
        );
        if (!!container) {
          // debugger;
          this.containerName = container.Value;
        }
      }
    },

    takePhoto() {
      var canvas = this.$refs.videoCanvas;
      var video = this.$refs.videoBox;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, 500, 500);
      var imgData = canvas.toDataURL("image/png");
      return this.convertBase64UrlToBuffer(imgData);
    },

    convertBase64UrlToBuffer(urlData) {
      var matches = urlData.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
      var type = matches[1];
      var buffer = new Buffer(matches[2], "base64");
      var data = {
        type: type,
        buffer: buffer,
      };
      return data;
    },
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]);
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/png" });
    },
    getCurrentVideoAppoint(
      isCheckCamera,
      videoAppointmentId,
      courseActivationId,
      isUseFreeVideoCount
    ) {
      this.loading = true;
      getCurrentVideoAppoint(videoAppointmentId, courseActivationId)
        .then((result) => {
          if (result.success) {
            if (this.bypassVideoAppointment) {
              if (result.data.IsCompleted) {
                this.$message.warning("该课程已完成观看,请刷新后重试。");
                this.loadingPayment = false;
                this.loading = false;
                return;
              }
            }

            this.onOpenDialog(
              isCheckCamera,
              videoAppointmentId,
              courseActivationId,
              isUseFreeVideoCount
            ).then((isOpen) => {
              if (isOpen) {
                let seconds = result.data.LeftSeconds;
                this.appStartTime = result.data.AppStartTimeText;

                this.timeDown(
                  result.data.AppStartDateTimeString,
                  result.data.AppEdnDateTimeString,
                  seconds
                );

                this.timer = setInterval(() => {
                  if (!this.isSproutPlayerPlay && !this.isAliyunVideoPlayerPlay) {
                    return;
                  }

                  seconds--;

                  this.timeDown(
                    result.data.AppStartDateTimeString,
                    result.data.AppEdnDateTimeString,
                    seconds
                  );

                }, 1000);
              }
            });
          } else {
            this.$message.error(result.message);
            this.loadingPayment = false;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loadingPayment = false;
          this.loading = false;
        });
    },
    timeDown(startDateStr, endDateStr, leftSeconds) {
      let totalSeconds = 0;
      if (!this.bypassVideoAppointment) {
        let endDate = new Date(endDateStr);
        let startDate = new Date(startDateStr);
        //当前时间
        let nowDate = new Date();

        if (startDate > nowDate) return;

        if (endDate < nowDate) {
          clearInterval(this.timer);
          this.openTimeDownDialog();
          return;
        }

        //相差的总秒
        totalSeconds = parseInt((endDate - nowDate) / 1000);

        if (totalSeconds <= 0) {
          // this.$message({
          //   message: '预约的视频播放时间已结束!',
          //   type: 'warning'});
          this.playerDialogVisible = false;
          this.playerDialogVisibleHjt = false;
          this.playerDialogVisibleH5 = false;
        }
      } else {
        totalSeconds = leftSeconds;
        if (totalSeconds <= 0) {
          clearInterval(this.timer);
          return;
        }
      }

      this.showTimeDown = true;
      let str = this.getTimespanString(totalSeconds);
      this.timeDownShow = "，剩余" + str;
    },
    getTimespanString(totalSeconds) {
      //取模（余数）
      let modulo = totalSeconds % (60 * 60 * 24);
      //小时
      let hours = Math.floor(modulo / (60 * 60));
      modulo = modulo % (60 * 60);
      //分钟
      let minutes = Math.floor(modulo / 60);
      //
      let seconds = modulo % 60;

      return hours + "h:" + minutes + "m:" + seconds + "s";
    },
    clearTimer() {
      this.closeCamera();
      this.playerDialogVisibleH5 = false;
      this.playerDialogVisibleHjt = false;
      this.sproutVideoViewVisible = false;
      this.aliyunVideoViewVisible = false;
      this.showTimeDown = false;
      this.clearIntervalTimer(this.timer);
      this.clearIntervalTimer(this.timerUpdateWatch);
      this.clearIntervalTimer(this.timerUpdateCaptureImage);
      this.clearIntervalTimer(this.timerCheckCamera);
    },
    clearIntervalTimer(timerObj) {
      if (!!timerObj) {
        clearInterval(timerObj);
        timerObj = null;
      }
    },
    updateCaptureImage(courseActivationId) {
      let row = this.getCurrentRow(courseActivationId);
      if (!!row) {
        let videoAppointmentId = row.Id;
        this.currentCourseActivationId = courseActivationId;
        if (!!videoAppointmentId) {
          var photo = this.takePhoto();
          var fileName =
            this.studentInfo.Phone +
            "_" +
            videoAppointmentId +
            "_" +
            courseActivationId +
            "_" +
            new Date().getTime() +
            ".png";
          uploadBufferToBlobStorage(
            fileName,
            photo.type,
            photo.buffer,
            this.containerName,
            this.sasKey,
            this.captureUploadCallBack
          );
        }
      }
    },
    captureUploadCallBack(result) {
      if (result.isSuccess) {
        let row = this.getCurrentRow(this.currentCourseActivationId);
        if (!!row) {
          let videoAppointmentId = row.Id;
          if (!!videoAppointmentId) {
            saveUploadFile({
              fileStorageType: this.CaptureImageType,
              sourceFileName: result.data.originalFileName,
              uploadFileName: result.data.blobFile.name,
            })
              .then((result) => {
                if (!!result && result.success) {
                  saveCaptureImage(
                    videoAppointmentId,
                    result.data.FileId,
                    false,
                    ""
                  );
                } else {
                  console.log("caputre image upload error");
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        }
      } else {
        saveCaptureImage(videoAppointmentId, null, true, result.errorMessage);
      }
    },
    onUploadError(err) {
      console.log("caputre image upload error:" + err.errorMessage);
    },
    updateWatch(videoAppointmentId, courseActivationId, isUseFreeVideoCount) {
      let count = 10;
      //let length = count * 1000;
      //let errorCount = 0;
      clearInterval(this.timerUpdateWatch);
      // for testing
      // length = count * 100000;
      // if (this.playerDialogVisibleH5 || this.playerDialogVisible){
      //   let row = this.listData.Results.find(i => i.CourseActivationId == courseActivationId);

      //   updateWatchSeconds(row.Id, courseActivationId, count, isUseFreeVideoCount).then(result =>{
      //     if (!!result && result.success){
      //       this.updateListDataRow(courseActivationId, count, result.data, isUseFreeVideoCount);
      //     }else{
      //       // errorCount ++;
      //       // if (errorCount >= 5){
      //         this.$message.error(result.message);
      //         this.clearTimer();
      //         this.clearTimerUpdateWatch();
      //       //}
      //     }
      //   });
      // }

      let watchSeconds = 0;
      this.timerUpdateWatch = setInterval(() => {
        if (
          this.aliyunVideoViewVisible ||
          this.sproutVideoViewVisible ||
          this.playerDialogVisibleH5 ||
          this.playerDialogVisible
        ) {
          if (!this.isSproutPlayerPlay && !this.isAliyunVideoPlayerPlay) {
            return;
          }

          watchSeconds++;

          if (watchSeconds == 0 || watchSeconds % count != 0) {
            return;
          }
          let row = this.currentRow;
          updateWatchSeconds(
            row.Id,
            courseActivationId,
            count,
            isUseFreeVideoCount
          ).then((result) => {
            if (!!result && result.success) {
              this.updateListDataRow(
                courseActivationId,
                count,
                result.data,
                isUseFreeVideoCount
              );
            } else {
              // errorCount ++;
              // if (errorCount >= 5){
              this.$message.error(result.message);
              this.clearTimer();
              //}
            }
          });
        }
      }, 1000);
    },
    getCurrentRow(courseActivationId) {
      return this.currentRow;
    },
    updateListDataRow(courseActivationId, seconds, data, isUseFreeVideoCount) {
      let row = this.getCurrentRow(courseActivationId);
      if (!!row) {
        if (!row.Id) {
          if (row.FreeWatchCount > 0) {
            row.FreeWatchCount--;
          }
          row.Id = data.VideoAppointmentId;

          if (isUseFreeVideoCount && !row.IsAppointment) {
            //this.studentInfo.FreeVideoCount --;
            let stuentFreeCourse =
              this.studentInfo.CourseFreeVideoCountList.find(
                (i) => i.CourseId == row.CourseId
              );
            stuentFreeCourse.FreeVideoCount--;

            if (stuentFreeCourse.FreeVideoCount == 0) {
              this.$refs.videoList.updateListDataRow();
              // this.listData.Results.forEach((x) => {
              //   if (x.Id != row.Id) {
              //     if (x.IsFreeWatchCountInTerm) {
              //       x.SignInStatus = x.SignInText;// + "(需缴费)";
              //     }
              //   }
              // });
            }
          }
          row.IsWatchApproved = true;

          if (row.IsCheckCamera) {
            setTimeout(() => {
              this.updateCaptureImage(courseActivationId);
            }, 500);
          }
        }

        if (row.WatchSeconds == 0) {
          row.WatchTimeText = new Date().format("yyyy-MM-dd hh:mm:ss");
        }

        row.WatchSeconds = row.WatchSeconds + seconds;
        let str = this.getTimespanString(row.WatchSeconds);
        row.WatchMinutesText = str;

        if (!!data.IsCompleted) {
          if (row.FreeWatchCount <= 0 && row.IsFreeVideo) {
            row.ViewEnable = false;
          }

          row.Id = 0;
          //row.WatchTimeText = "";
          //row.WatchMinutesText = "";
        }
      }

      if (!!data.IsCompleted) {
        this.clearTimer();
        this.$message("课程已观看完毕");
        if (this.activeTab === '1'){
          this.$refs.videoList.search();
        }else{
          this.$refs.appointmentList.search();
        }
      }
    },
    onCloseSproutVideo() {
      this.sproutVideoViewVisible = false;
      this.isSproutPlayerPlay = false;
      if (this.bypassVideoAppointment) {
        this.clearTimer();
      } else {
        this.clearSproutPlayer();
      }
    },
    viewSproutVideo(
      videoAppointmentId,
      courseActivationId,
      isUseFreeVideoCount,
      row
    ) {
      this.sproutVideoViewVisible = true;

      if (this.sproutVideoPath != row.SproutVideoPath) {
        this.isVideoloading = true;
        this.sproutVideoId = row.SproutId;
        this.sproutVideoPath = row.SproutVideoPath;
        //this.sproutVideoPath = "<iframe class='sproutvideo-player' src=''></iframe>";
      }

      this.updateWatch(
        videoAppointmentId,
        courseActivationId,
        isUseFreeVideoCount
      );
    },
    createSproutPlayer() {
      this.clearSproutPlayer();
      let seconds = 0;
      let checkPlayerTimer = setInterval(() => {
        try {
          seconds++;
          if (seconds >= 20) {
            clearInterval(checkPlayerTimer);
            checkPlayerTimer = null;
            this.$message({
              message: "加载视频出现异常，请刷新页面后重试。",
              type: "warning",
              duration: 0
            });
          }

          this.sproutPlayer = new SV.Player({ videoId: this.sproutVideoId });
          
          if (this.sproutPlayer && this.sproutPlayer.bind) {
            this.sproutPlayer.bind("play", this.onSproutPlayerPlay);
            this.sproutPlayer.bind("pause", this.onSproutPlayerPause);
 
            this.isVideoloading = false;
            clearInterval(checkPlayerTimer);
            checkPlayerTimer = null;
          }
        } catch (e) {

        }
      }, 1000);

    },
    clearSproutPlayer() {
      if (this.sproutPlayer) {
        this.isSproutPlayerPlay = false;
        this.sproutPlayer.unbind("play", this.onSproutPlayerPlay);
        this.sproutPlayer.unbind("pause", this.onSproutPlayerPause);
        this.sproutPlayer = null;
      }
    },
    onSproutPlayerPlay(e) {
      if (this.activeTab === '2' && this.currentEventData && this.currentEventData.row 
        && this.currentEventData.row.IsAppointment && this.pauseTime){
        let currentTime = new Date();
        let validTime = new Date(Date.parse(this.pauseTime));
        let validMinutes = 5;
        validTime.setMinutes(validTime.getMinutes() + validMinutes);
        if (currentTime > validTime){
          this.pauseTime = null;
          this.clearTimer();
          this.$refs.appointmentList.customEventHandler(this.currentEventData);
          return;
        }
      }
      this.isSproutPlayerPlay = true;
      this.pauseTime = null;
    },
    onSproutPlayerPause(e) {
      this.isSproutPlayerPlay = false;
      this.pauseTime = new Date();
    },
    openStudentQuestionnaireEditor(studentId, courseId) {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "studentQuestionnaireEditor"
      );
      if (!refEditor) return;

      refEditor.showDialog(studentId, courseId);
    },
    onStudentQuestionnaireEditorCompleted() {
      let data = this.currentEventData;

      let questionnaireStatus = this.studentCoursesQuestionnaireStatus.find(item => item.CourseId === data.row.CourseId);
      if (!!questionnaireStatus) {
        questionnaireStatus.HaveActiveQuestionnaires = false;
      }
      
      this.handleAppointment();
    },
    showTokenEditor(videoAppointmentId) {
      this.tokenEditorData = {
        videoAppointmentId: videoAppointmentId
      };
      this.tokenEditorVisible = true;
    },
    onTokenValid() {
      this.tokenEditorVisible = false;
      this.handleViewVideo(this.currentEventData);
    },
    getMainDomain(host) {
        // 处理特殊情况和IP地址
        if (host === 'localhost' || /^(\d{1,3}\.){3}\d{1,3}$/.test(host) || host.includes(':')) {
            return host;
        }
        
        const parts = host.split('.');
        
        // 简单处理：如果域名部分大于2，取最后两部分
        if (parts.length > 2) {
            return parts.slice(-2).join('.');
        }
        
        return host;
    },
    onCloseAliyunVideo() {
      this.aliyunVideoViewVisible = false;
      this.isAliyunVideoPlayerPlay = false;
      if (this.bypassVideoAppointment) {
        this.clearTimer();
      } else {
        this.clearaliyunVideoPlayer();
      }
    },
    viewAliyunVideo(
      videoAppointmentId,
      courseActivationId,
      isUseFreeVideoCount,
      row
    ) {
      this.aliyunVideoViewVisible = true;

      if (this.aliyunVideoId != row.AliyunVideoId) {
        this.canPlayVideo = false;
        this.isVideoloading = true;
        this.aliyunVideoId = row.AliyunVideoId;
        this.aliyunVideoPath = row.AliyunVideoPath;
        this.availableMinutes = row.AvailableMinutes;
        this.aliyunVideoRegionId = row.AliyunVideoRegionId;
      }

      this.$nextTick(() => {
        this.createAliyunVideoPlayer();
      });

      this.updateWatch(
        videoAppointmentId,
        courseActivationId,
        isUseFreeVideoCount
      );
    },
    async createAliyunVideoPlayer() {
      this.clearAliyunVideoPlayer();

      try {
        const result = await this.getStsCredentialsWithRetry();
        if(result && result.success){
          let credentials = result.data;
          //console.log('aliyunVideoId:', this.aliyunVideoId)
          //console.log('credentials:', credentials);
          // 验证必要的凭证参数
          if (!credentials.AccessKeyId || !credentials.AccessKeySecret || !credentials.SecurityToken) {
            console.error('STS凭证不完整，无法播放DRM加密视频', credentials);
            this.isVideoloading = false;
            return;
          }
          
          let authTimeout = 7200;
          if (this.availableMinutes > 120){
            authTimeout = (this.availableMinutes + 10) * 60;
          }
         
          // 检查凭证是否即将过期
          this.checkStsCredentialExpiry(credentials);
          
          // 检查浏览器DRM支持情况
          const drmSupport = this.checkBrowserDRMSupport();
          //console.log('DRM支持情况:', drmSupport);

          let useDrm = true;//!drmSupport.supportsFairPlay;
          let hasHlsAliyunVideo = false;

          let hostname = this.getMainDomain(window.location.hostname);
          var config = {
            id: 'aliyunVideoPlayer',
            width: '100%',
            height: '600px',
            autoplay: false,
            authTimeout: authTimeout,
            
            // DRM播放使用vid而不是source
            vid: this.aliyunVideoId,
            //source: videoPlaylistUrl,
            //playauth: '', // 确保不使用playauth

            // STS凭证参数映射
            accessKeyId: credentials.AccessKeyId,
            accessKeySecret: credentials.AccessKeySecret, 
            securityToken: credentials.SecurityToken,
            region: credentials.RegionId, // 提供默认区域

            mediaType: "video",
            license: {
              domain: hostname, // 使用当前域名
              key: credentials.LicenseKey, // 申请成功后，在控制台可以看到 License Key
            },
            // 播放器配置
            useH5Prism: true, // 使用H5播放器
            useFlashPrism: false, // 禁用Flash播放器
            loading: true,
            preload: true, // 预加载视频
            keyShortCuts: true
          };
          
          if (useDrm){
            config.format = 'm3u8';// 明确指定HLS格式
            config.isDrm = true;
            config.enableDRM = true;
            config.drmSessionTimeout = 20000;
          } 
          // else if (hasHlsAliyunVideo && !isIOSDevice()){
          //   config.format = 'm3u8';
          //   config.drmSessionTimeout = 20000;
          // }

          if (useDrm && drmSupport.supportsFairPlay){
            config.certId = credentials.CertId;
          }

          this.$nextTick(() => {
            try {
              // 初始化阿里云播放器 - 修正DRM配置
              this.aliyunVideoPlayer = new Aliplayer(config, (player) => {
                //console.log('阿里云播放器创建完成');
                //this.isVideoloading = false;
              });

              if (!!this.aliyunVideoPlayer) {
                // 添加播放器事件监听
                this.aliyunVideoPlayer.on('ready', this.onAliyunVideoPlayerReady);          
                this.aliyunVideoPlayer.on('error', this.onAliyunVideoPlayerError);
                this.aliyunVideoPlayer.on("canplay", this.onAliyunVideoPlayerCanplay);
                this.aliyunVideoPlayer.on("play", this.onAliyunVideoPlayerPlay);
                this.aliyunVideoPlayer.on("pause", this.onAliyunVideoPlayerPause);
              }

            } catch (e) {
              //this.isVideoloading = false;
              console.error("初始化阿里云播放器失败", e);
            }
          });

        } else {
          console.error('获取阿里云STS凭证失败:', result);
          //this.isVideoloading = false;
        }
      } catch (error) {
        console.error('获取STS凭证时发生错误:', error);
        //this.isVideoloading = false;
      }
    },
    clearAliyunVideoPlayer() {
      if (this.aliyunVideoPlayer) {
        this.isAliyunVideoPlayerPlay = false;
        this.aliyunVideoPlayer.off("ready", this.onAliyunVideoPlayerReady);
        this.aliyunVideoPlayer.off("error", this.onAliyunVideoPlayerError);
        this.aliyunVideoPlayer.off("canplay", this.onAliyunVideoPlayerCanplay);
        this.aliyunVideoPlayer.off("play", this.onAliyunVideoPlayerPlay);
        this.aliyunVideoPlayer.off("pause", this.onAliyunVideoPlayerPause);
        this.aliyunVideoPlayer.dispose();
        this.aliyunVideoPlayer = null;
      }
    },
    onAliyunVideoPlayerReady(){
      setTimeout(()=>{
        this.isVideoloading = false;
      }, 8000);
      //console.log('播放器准备就绪');
    },
    onAliyunVideoPlayerError(error){
      console.error('播放器错误:', error);
      if (this.hideAliyunVideoPlayerError){
        // 通过CSS类名找到错误信息显示组件并隐藏它
        var errorElement = document.querySelector('.prism-ErrorMessage');
        if (errorElement) {
          errorElement.style.display = 'none';
        }
      }
      let data = error && error.paramData;
      console.error('播放器错误 data:', data);
      
      // 安全地获取错误信息
      const errorMessage = error && error.message ? error.message : '';
      const errorCode = error && error.code ? error.code : '';
      
      // 处理特定的DRM和权限错误（仅记录到控制台，不显示给用户）
      if (errorCode === 'AccessDenied' || errorMessage.includes('AccessDenied')) {
        console.error('视频访问权限不足，可能是DRM权限问题', error);
        this.handleStsCredentialExpired();
      } else if (errorCode === 'Forbidden' || errorMessage.includes('Forbidden')) {
        console.error('视频访问被禁止，请检查播放权限', error);
        this.handleStsCredentialExpired();
      } else if (errorMessage.includes('bucket acl')) {
        console.error('OSS存储桶权限不足，请联系管理员', error);
        this.handleStsCredentialExpired();
      } else if (errorCode === 'DRM_LICENSE_ERROR' || errorMessage.includes('DRM')) {
        console.error('DRM许可证获取失败，请检查DRM配置', error);
      } else if (errorCode === 'DRM_NOT_SUPPORTED') {
        console.error('当前浏览器不支持DRM播放，请使用支持的浏览器', error);
      } else {
        console.error('视频播放出错:', errorMessage || '未知错误', error);
      }

      // 安全地序列化错误对象，避免循环引用问题
      try {
        const userAgent = navigator.userAgent.toLowerCase();
        let msg = '';
        
        if (error) {
          try {
            // 尝试直接序列化
            msg = JSON.stringify(error);
          } catch (e) {
            // 如果失败，尝试提取关键信息
            msg = JSON.stringify({
              code: errorCode,
              message: errorMessage,
              type: error.constructor ? error.constructor.name : typeof error,
              paramData: data,
              toString: error.toString ? error.toString() : String(error)
            });
          }
        } else {
          msg = 'error对象为null或undefined';
        }
        
        // 调用错误记录函数，并处理可能的异常
        saveClientSideError("阿里云播放器错误", `userAgent:${userAgent},error:${msg}`)
          .catch(err => {
            console.error('保存客户端错误信息失败:', err);
          });
      } catch (e) {
        console.error('处理错误信息时发生异常:', e);
        // 即使序列化失败，也尝试记录基本信息
        try {
          const userAgent = navigator.userAgent.toLowerCase();
          saveClientSideError("阿里云播放器错误", `userAgent:${userAgent},error:处理错误时发生异常-${e.message || e.toString()}`)
            .catch(err => {
              console.error('保存客户端错误信息失败:', err);
            });
        } catch (finalErr) {
          console.error('最终错误记录失败:', finalErr);
        }
      }
    }, 
    onAliyunVideoPlayerCanplay(){
      this.canPlayVideo = true;
      this.isVideoloading = false;
    }, 
    onAliyunVideoPlayerPlay(e) {
      setTimeout(() => {
        const t = this.aliyunVideoPlayer.getCurrentTime();
        if (!this.canPlayVideo && t < 5){
          this.aliyunVideoPlayer.seek(5);
        }

        if (this.activeTab === '2' && this.currentEventData && this.currentEventData.row 
          && this.currentEventData.row.IsAppointment && this.pauseTime){
          let currentTime = new Date();
          let validTime = new Date(Date.parse(this.pauseTime));
          let validMinutes = 5;
          validTime.setMinutes(validTime.getMinutes() + validMinutes);
          if (currentTime > validTime){
            this.pauseTime = null;
            this.clearTimer();
            this.$refs.appointmentList.customEventHandler(this.currentEventData);
            return;
          }
        }
        this.isAliyunVideoPlayerPlay = true;
        this.pauseTime = null;
      }, 100);
    },
    onAliyunVideoPlayerPause(e) {
      this.isAliyunVideoPlayerPlay = false;
      this.pauseTime = new Date();
    },
    // 处理STS凭证过期的情况
    handleStsCredentialExpired() {
      console.warn('STS凭证可能已过期，尝试重新获取');
      // 清除当前播放器
      this.clearAliyunVideoPlayer();
      // 重新创建播放器
      setTimeout(() => {
        this.createAliyunVideoPlayer();
      }, 1000);
    },
    // 带重试机制的STS凭证获取
    async getStsCredentialsWithRetry(maxRetries = 3) {
      let retryCount = 0;
      
      while (retryCount < maxRetries) {
        try {
          const result = await getStsCredentials(this.aliyunVideoRegionId);
          if (result && result.success) {
            return result;
          }
          retryCount++;
          if (retryCount < maxRetries) {
            console.log(`STS凭证获取失败，第${retryCount}次重试...`);
            await new Promise(resolve => setTimeout(resolve, 2000 * retryCount)); // 递增延迟
          }
        } catch (error) {
          retryCount++;
          console.error(`获取STS凭证时发生错误，第${retryCount}次尝试:`, error);
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, 2000 * retryCount));
          }
        }
      }
      
      throw new Error(`获取STS凭证失败，已重试${maxRetries}次`);
    },
    // 检查STS凭证是否即将过期
    checkStsCredentialExpiry(credentials) {
      if (credentials.Expiration) {
        const expirationTime = new Date(credentials.Expiration);
        const currentTime = new Date();
        const timeDiff = expirationTime.getTime() - currentTime.getTime();
        const minutesLeft = Math.floor(timeDiff / (1000 * 60));
        
        if (minutesLeft < 5) {
          console.warn(`STS凭证将在${minutesLeft}分钟后过期`);
        }
      }
    },
    // 检查浏览器DRM支持情况
    checkBrowserDRMSupport() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isChrome = userAgent.includes('chrome');
      const isFirefox = userAgent.includes('firefox');
      const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
      const isEdge = userAgent.includes('edge');
      
      console.log('浏览器信息:', {
        userAgent: navigator.userAgent,
        isChrome,
        isFirefox,
        isSafari,
        isEdge
      });
      
      // 检查Widevine支持（Chrome, Firefox, Edge）
      if (isChrome || isFirefox || isEdge) {
        if (navigator.requestMediaKeySystemAccess) {
          navigator.requestMediaKeySystemAccess('com.widevine.alpha', [{
            initDataTypes: ['cenc'],
            audioCapabilities: [{
              contentType: 'audio/mp4;codecs="mp4a.40.2"',
              robustness: 'SW_SECURE_CRYPTO'
            }],
            videoCapabilities: [{
              contentType: 'video/mp4;codecs="avc1.42E01E"',
              robustness: 'SW_SECURE_CRYPTO'
            }]
          }]).then(() => {
            console.log('浏览器支持Widevine DRM');
          }).catch((error) => {
            console.warn('浏览器不支持Widevine DRM:', error);
          });
        }
      }
      
      // 检查FairPlay支持（Safari）
      if (isSafari) {
        console.log('Safari浏览器，支持FairPlay DRM');
      }
      
      return {
        supportsWidevine: isChrome || isFirefox || isEdge,
        supportsFairPlay: isSafari
      };
    },
  },
  watch: {
    sproutVideoPath(val) {
      if (val) {
        this.$nextTick(() => {
          this.createSproutPlayer();
        });
      }
    },
    // aliyunVideoId(val) {
    //   if (val) {
    //     this.$nextTick(() => {
    //       this.createAliyunVideoPlayer();
    //     });
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.video-appointment-list-content {
  height: 90%;
  padding: 10px 40px 40px 20px;

  .grid-content {
    //min-width: 800px;
    max-height: 530px;
    overflow: auto;
  }
}

.backgroud-light-gray {
  background-color: #f0f0f0;
}

.footer-description {
  font-size: 12px;
  background-color: #1756a6;
  height: 10%;
  width: 100%;
  position: absolute;
  bottom: 0;

  span {
    color: white;

    a {
      color: white;
      text-decoration: underline;
      cursor: pointer;
    }

    &.cs-video-warning {
      font-weight: bold;
      color: red;
      font-size: 20px;
    }
  }

  footer {
    text-align: left;
  }

  .footer-content {
    margin-top: 5px;
  }

  .footer-left {
    font-size: 15px;

    span {
      display: block;
    }

    .cs-footer-time {
      font-size: 20px;
    }
  }

  .footer-right {
    font-size: 14px;
    text-align: right;
  }
}

.cs-title-color {
  color: #999999;
}

.cs-courseFreeVideoCountList-container {
  max-height: 650px;
  overflow: hidden;
}

.cs-courseFreeVideoCountList {
  margin-top: 70px;
  margin-left: 30px;

  span {
    display: block;
    margin-right: 8px;
  }
}

.cs-video-notice {
  margin-top: 20px;
}

.cs-video-warning {
  font-weight: bold;
  color: red;
}
</style>

<style lang="scss">
.cs-videoPlayerHjt {
  .pv-video-player {
    margin: auto;
  }
}

.cs-sproutVideo-container,
.cs-aliyunVideo-container {
  .el-dialog__headerbtn {
    top: 10px;
  }
}

.cs-aliyunVideo-player-container{
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/page/videoAppointmentList.vue